import { useState } from 'react'

import { Loader, Text } from '@mantine/core'

import { useLocation, useParams } from '@redwoodjs/router'
import { Metadata, useQuery } from '@redwoodjs/web'

import { VALIDATE_VOE_TOKEN } from 'src/graphql/voeResponseAuth.graphql'

import VoEOtpGate from './components/VoEOtpGate'
import VoEResponseFormV2 from './components/VoEResponseFormV2'

const VoEResponseV2Page = () => {
  const { voeId } = useParams()
  const { search } = useLocation()
  const token = new URLSearchParams(search).get('token') ?? ''
  const [sessionToken, setSessionToken] = useState<string | null>(
    () => sessionStorage.getItem(`voe_session_${voeId}`)
  )

  const { data, loading } = useQuery(VALIDATE_VOE_TOKEN, {
    variables: { voeId, token },
    skip: !token,
  })

  if (!token) {
    return <ErrorScreen message="Invalid link. No token provided." />
  }

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader />
      </div>
    )
  }

  if (!data) {
    return <ErrorScreen message="Could not validate link. Please try again." />
  }

  const validation = data.validateVoEToken
  if (validation.alreadySubmitted) {
    return <ErrorScreen message="This VoE response has already been submitted." />
  }
  if (!validation.valid) {
    return (
      <ErrorScreen message="This link has expired or is invalid. Contact the company that sent this request for a new link." />
    )
  }

  if (!sessionToken) {
    return (
      <VoEOtpGate
        voeId={voeId}
        token={token}
        allowedDomain={validation.allowedDomain ?? null}
        onAuthorized={setSessionToken}
      />
    )
  }

  return (
    <>
      <Metadata
        title="VoE Response"
        description="VoE Response page"
        robots="noindex,nofollow"
      />
      <VoEResponseFormV2
        voeId={voeId}
        sessionToken={sessionToken}
        onSessionExpired={() => {
          sessionStorage.removeItem(`voe_session_${voeId}`)
          setSessionToken(null)
        }}
      />
    </>
  )
}

const ErrorScreen = ({ message }: { message: string }) => (
  <div className="flex min-h-screen items-center justify-center bg-doubleNickel-gray-50">
    <div className="max-w-md rounded-lg border border-doubleNickel-gray-200 bg-white p-8 text-center shadow-sm">
      <Text fw={500} size="lg" className="text-doubleNickel-gray-700">
        {message}
      </Text>
    </div>
  </div>
)

export default VoEResponseV2Page
